module.exports = __webpack_public_path__ + "img/crop_info_back_head.6692ac84.png";